import React, { Fragment } from 'react'
import cn from 'classnames'
import { Header, SubHeader } from 'shared/components/ui/Typography'
import { Form, Checkbox, Button, Loader } from 'util/ui'
import { propFunc } from 'util/functions'
import sharedStyles from '../../sharedForm/styles.less'
import styles from './styles.less'

class FacebookPagesPage extends React.PureComponent {
  handleOnChange = (pageId, e, { checked }) => {
    this.props.onChange(pageId, checked)
  }

  render() {
    const {
      fetching,
      availablePages,
      formFields,
      submitForm,
      canSave,
      doCancel,
      hasDirtyFields,
    } = this.props
    return (
      <Fragment>
        <Header size="medium" as="h1">
          Facebook
        </Header>
        <SubHeader size="small" as="h2">
          Which pages would you like to connect to your Groove account?
        </SubHeader>
        {fetching && (
          <Fragment>
            <Form.Field>
              <hr />
            </Form.Field>
            <Loader size="large" />
            <Form.Field>
              <hr />
            </Form.Field>
          </Fragment>
        )}
        {!fetching && (
          <Form size="large" className={sharedStyles.form}>
            <Form.Field>
              <hr />
            </Form.Field>
            {availablePages.map(page => (
              <Form.Field key={page.id}>
                <Checkbox
                  label={page.name}
                  name={page.name}
                  checked={formFields[page.id]}
                  onChange={propFunc(this.handleOnChange, page.id)}
                />
              </Form.Field>
            ))}
            <Form.Field>
              <hr />
            </Form.Field>
            <Form.Group>
              <Form.Field width={4}>
                <Button
                  fluid
                  basic
                  size="big"
                  content="Back"
                  onClick={doCancel}
                />
              </Form.Field>
              <Form.Field width={12}>
                <Button
                  primary
                  fluid
                  size="big"
                  content="Link pages"
                  onClick={hasDirtyFields ? submitForm : doCancel}
                  disabled={!canSave}
                />
                <a
                  href="#skipstep"
                  className={cn(sharedStyles.skipStep, styles.skipStep)}
                >
                  {"I'll subscribe to my pages later"}
                </a>
              </Form.Field>
            </Form.Group>
          </Form>
        )}
      </Fragment>
    )
  }
}

export default FacebookPagesPage
